"use strict";
/**
 * Markets Search
 * Search and filter functionality for markets and events
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCachedDisplayEvents = getCachedDisplayEvents;
exports.searchEvents = searchEvents;
exports.searchDisplayEvents = searchDisplayEvents;
exports.searchMarkets = searchMarkets;
const cache_1 = require("./cache");
const registry_1 = require("../venues/registry");
/**
 * Get cached display events (unified format for both providers)
 */
function getCachedDisplayEvents(dataSource) {
    return (0, registry_1.getVenue)(dataSource).cachedEvents();
}
/**
 * Search events by title or subtitle
 */
function searchEvents(searchTerm, events) {
    const list = events || (0, cache_1.getKalshiEventCache)();
    const term = searchTerm.toLowerCase();
    return list.filter((event) => event.title.toLowerCase().includes(term) ||
        event.sub_title.toLowerCase().includes(term));
}
/**
 * Search display events by title or subtitle (unified for both providers)
 */
function searchDisplayEvents(searchTerm, events, dataSource = "kalshi") {
    const list = events || getCachedDisplayEvents(dataSource);
    const term = searchTerm.toLowerCase();
    return list.filter((event) => event.title.toLowerCase().includes(term) ||
        event.subtitle.toLowerCase().includes(term));
}
/**
 * Search markets by title or subtitle
 * LEGACY: Kept for backward compatibility
 */
function searchMarkets(searchTerm, markets) {
    const list = markets || (0, cache_1.getKalshiMarketCache)();
    const term = searchTerm.toLowerCase();
    return list.filter((market) => market.title.toLowerCase().includes(term) ||
        market.subtitle.toLowerCase().includes(term));
}
